import styled from "styled-components";
import global from "../../global";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  padding-bottom: 24px;
`;

export const TopLayoutGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.8fr;
  gap: 16px;
  margin-bottom: 24px;
  width: 100%;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`;

export const LeftColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const MobileActionsWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;

    /* Ensure child components fill the space */
    & > * {
      width: 100%;
    }
    
    /* Target the Filter container specifically */
    & > div:first-child {
      width: 100%;
    }
    
    /* Target the PrimaryButton container specifically */
    & > button {
      width: 100%;
    }
  }
`;

export const DesktopActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MainMetricsCard = styled.div`
  background: var(--white);
  border: 1px solid rgba(0,0,0,0.04);
  border-radius: 16px;
  padding: 20px 24px 0px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  width: 100%;
  position: relative;
  height: 100%;
  overflow: hidden;
`;

export const MainMetricsInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
  z-index: 2; /* Keep text above the bleeding chart */
`;

export const MainMetricTextContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 100%;
`;

export const MainMetricsChart = styled.div`
  width: calc(100% + 48px);
  margin-left: -24px;
  margin-right: -24px;
  margin-bottom: 0px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1; /* Keep chart behind the main metric texts */
`;

export const MainMetricValue = styled.div`
  font-size: 48px;
  font-weight: 700;
  color: var(--fixit);
  margin-top: 12px;
  margin-bottom: 24px;
  line-height: 1;
`;

export const SideMetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: 16px;
  height: 100%;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const ChartTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ViewAllLink = styled.button`
  background: transparent;
  color: var(--fixit);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 24px;

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    width: 100%;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }
`;

export const DesktopPrimaryButtonWrapper = styled.div`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobilePrimaryButtonWrapper = styled.div`
  display: none;
  width: 100%;
  @media (max-width: 768px) {
    display: block;
    margin-top: 16px;
  }
`;

export const HeaderActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-end;
  }
`;



export const MainChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

export const ChartArea = styled.div`
  border: 1px solid rgba(0,0,0,0.04);
  border-radius: 6px;
  padding: 20px;
  background: var(--white);
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  width: 100%;
  position: relative;
`;

export const ChartTitle = styled.label`
  font-size: 16px;
  font-weight: 600;
  color: var(--dark-gray);
  margin-bottom: 12px;
`;

export const LockedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #fef3f2;
  color: #b42318;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 100px;
  border: 1px solid rgba(180, 35, 24, 0.15);
  white-space: nowrap;

  svg {
    font-size: 12px;
  }
`;

export const dashboardTooltipProps = {
  tooltip: {
    sx: {
      backgroundColor: "var(--dark-gray)",
      color: "var(--white)",
      fontSize: "13px",
      fontWeight: "500",
      padding: "8px 14px",
      borderRadius: "6px",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
      maxWidth: "280px",
      lineHeight: 1.4,
    }
  },
  arrow: {
    sx: {
      color: "var(--dark-gray)"
    }
  }
};



